import { InvoiceFrequencyEnum } from "@/modules/profile/interfaces/customer";

export const invoiceFrequencyOptions = [
  {
    label: "Mensuelle",
    value: InvoiceFrequencyEnum.MONTHLY,
  },
  {
    label: "Par commande",
    value: InvoiceFrequencyEnum.PER_ORDER,
  },
];

export const billingDayOptions = [
  {
    label: "1er du mois",
    value: "1",
  },
  {
    label: "5 du mois",
    value: "5",
  },
  {
    label: "10 du mois",
    value: "10",
  },
  {
    label: "15 du mois",
    value: "15",
  },
  {
    label: "20 du mois",
    value: "20",
  },
  {
    label: "25 du mois",
    value: "25",
  },
  {
    label: "Dernier jour du mois",
    value: "last",
  },
];
